import { shape, number } from 'prop-types';

export default shape({
  current_retirement_prediction: number,
  contribution_per_month_to_retire_at_desired_age: number,
});
